<template>
  <div class="long-text-tooltip">
    <el-popover
      placement="top"
      width="300"
      trigger="hover"
      :content="text"
      popper-class="long-text-popover"
    >
      <span slot="reference" class="text-trigger">
        {{ displayText }}
      </span>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: "LongTextTooltip",
  props: {
    text: {
      type: String,
      default: ""
    },
    maxLength: {
      type: Number,
      default: 20
    }
  },
  computed: {
    displayText() {
      if (!this.text) return "-";
      if (this.text.length <= this.maxLength) return this.text;
      return this.text.substring(0, this.maxLength) + "...";
    }
  }
};
</script>

<style lang="less" scoped>
.text-trigger {
  cursor: pointer;
  color: #606266;
}
</style>

<style lang="less">
.long-text-popover {
  max-width: 300px !important;
  word-wrap: break-word !important;
  word-break: break-word !important;
  white-space: normal !important;
  background-color: #000000 !important;
  color: #ffffff !important;
  border: none !important;
}

.long-text-popover,
.long-text-popover * {
  color: #ffffff !important;
}

.long-text-popover .el-popover__title {
  color: #ffffff !important;
}

.long-text-popover[x-placement] {
  background-color: #000000 !important;
}

.long-text-popover .el-popper__arrow::before {
  border-top-color: #000000 !important;
  border-bottom-color: #000000 !important;
}
</style>
